import config from 'src/constants';
import { authHeader } from '../_helpers';
import axiosInstance from '../axios-orders';
import { Error, ErrorOutline } from '@material-ui/icons';
import {fetchWrapper} from '../_helpers/fetch-wrapper';
import axios from 'axios';
import moment from 'moment';

export const homologationService = {
  insertTramiteH
};
const LOGIN_URL = '/api/identity/oauth/token';

  function insertTramiteH(tramite,documentList) 
  { 
     
      let user = JSON.parse(localStorage.getItem('user'));
      var now = moment().format();
      let id = JSON.parse(localStorage.getItem('ocUserId'));          
       var formData = new FormData();       
       formData.append('files', tramite[0]);
       formData.append('files', tramite[1]);
       formData.append('files', tramite[2]);
       formData.append('files', tramite[3]);
       formData.append('files', tramite[4]);      
     formData.append('operation', new Blob([JSON.stringify({
      "address": tramite.address,
      "city": tramite.city,
      "completeTimeYears": tramite.completeTimeYears,
      "countryId": tramite.countryId,
      "creditsCount": tramite.creditsCount,
      "defenseYear": tramite.defenseYear,
      "distanceTimeYears": tramite.distanceTimeYears,
      "documentList": documentList,
      "documents": "",
      "firstname": tramite.FirstName,
      "folio": tramite.folio,
      "gender": tramite.gender,
      "graduationYear": tramite.graduationYear,
      "id": 0,
      "idcard": tramite.ci,
      "institutionId": tramite.institutionId,
      "lastname": tramite.LastName,
      "masterTitle":tramite.masterTitle,
      "modality": tramite.modality,
      "nationality": "cubana",
      "number": tramite.number,
      "organism": tramite.organism,
      "partialTimeYears": tramite.partialTimeYears,
      "phone": tramite.phone,
      "photo": "",
      "position": tramite.position,
      "procedureDate": now,
      "programHours": tramite.programHours,
      "scienceBranch": tramite.scienceBranch,
      "scientificCategoryId": 0,
      "state": "",
      "teachingCategoryId": 0,
      "thesisTitle": tramite.thesisTitle,
      "tome": tramite.tome,
      "type": "",
      "userId": id,
      "workPhone": tramite.workphone,
      "workplace": tramite.workplace
      })], {type: 'application/json'}));  

  

   
     return axiosInstance().post('/api/homologation/register',formData).then(data => 
      {
        return data;        
     });

   
 }



